export default __webpack_public_path__ + "static/icon-medication-blue-6cb7c6872a90b0437754003075b96ff0.png";